var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.vendorsMap.length)?_c('div',{staticClass:"vendor-badge",style:({backgroundColor: _vm.vendor.color_hex})},[_vm._v(" "+_vm._s(_vm.vendor.name[0])+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }